<div class="row requestType mb-4">
  <div class="col-sm-12">
    <h1 class="text-primary mb-4">{{'WorkflowCreatePM.PreStage.CardIdentificacao.Title' | translate}}</h1>
  </div>

  <div class="col-sm-12">
    <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepSender.Cards.SenderQualification.Title' | translate}}</h2>
  </div>

  <!--É habilitando? -->
  <div class="col-sm-12 mt-3">
    <div class="form-check mb-2">
      <input class="form-check-input"
             aria-controls="collapseManual"
             type="checkbox"
             [(ngModel)]="model.isBeneficiary"
             [checked]="model.isBeneficiary?.toString()=='true'"
             name="isBeneficiary"
             (change)="isBeneficiaryChanged($event.target.checked)"
             [disabled]="model.notEditable?.toString()=='true'"
             id="isBeneficiary">
      <label class="form-check-label align-items-center " for="isBeneficiary">
        {{'WorkflowCreatePM.PreStage.CardIdentificacao.Habilitando' | translate}}
        <span class="text-primary ml-1" aria-label="Tooltip com informação" [ngClass]="isVisibleIsBeneficiary ? 'icon-minus' : 'icon-more'" (click)="$event.preventDefault(); $event.stopPropagation(); toggleVisibilityIsBeneficiary();"></span>
      </label>
      <div class="pt-2 text-gray-600 mt-1 mb-2" *ngIf="isVisibleIsBeneficiary" style="text-align: justify;">
        <span>{{'WorkflowCreatePM.PreStage.CardIdentificacao.HabilitandoTooltip' | translate}}</span>
        <br />
        <span>{{'WorkflowCreatePM.PreStage.CardIdentificacao.HabilitandoTooltipExtra' | translate}}</span>
      </div>
    </div>
  </div>
  <!--É Representante Legal? -->
  <div class="col-sm-12 mt-3">
    <div class="form-check mb-2">
      <input class="form-check-input"
             aria-controls="collapseManual"
             type="checkbox"
             [disabled]="model.notEditable?.toString()=='true' || isLegalRepresentationEnabled?.toString()=='false'"
             [(ngModel)]="model.isLegalRepresentative"
             [checked]="model.isLegalRepresentative?.toString()=='true'"
             (change)="isLegalRepresentativeChanged($event.target.checked)"
             name="isLegalRepresentative"
             id="isLegalRepresentative">
      <label class="form-check-label align-items-center " for="isLegalRepresentative">
        {{'WorkflowCreatePM.PreStage.CardIdentificacao.RepresentanteLegal' | translate}}
        <span class="text-primary ml-1" aria-label="Tooltip com informação" [ngClass]="isVisibleIsLegalRepresentative ? 'icon-minus' : 'icon-more'" (click)="$event.preventDefault(); $event.stopPropagation(); toggleVisibilityIsLegalRepresentative();"></span>
      </label>
      <div class="pt-2 text-gray-600 mt-1 mb-2" *ngIf="isVisibleIsLegalRepresentative" style="text-align: justify;">
        <span>{{'WorkflowCreatePM.PreStage.CardIdentificacao.RepresentanteLegalTooltip' | translate}}</span>
        <br />
        <span>{{'WorkflowCreatePM.PreStage.CardIdentificacao.RepresentanteLegalTooltipExtra' | translate}}</span>
      </div>

    </div>
  </div>
</div>
